// extracted by mini-css-extract-plugin
export var itemLink = "D_b8";
export var itemIcon = "D_3";